import {ImageModel} from "./data/models/image.model";
import {DomSanitizer} from "@angular/platform-browser";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ImageHandler {

  constructor(private sanitizer: DomSanitizer) {
  }


  public handleImage(image: ImageModel, altText: string): ImageModel {
    if (image && image.file && image.type) {
      image.altText = altText;
      image.srcUrl = this.sanitizer.bypassSecurityTrustResourceUrl('data:' + image.type + ';base64,' + image.file);
    }
    return image;
  }
}
